<template>
  <fts-modal
    :full-screen="fullView"
    append-container-class="quick-view-modal-container"
    header-class="quick-view__header loc-header"
    content-class="quick-view__content"
    footer-class="quick-view__footer"
    width="100%"
    :backdrop="isBackdrop"
    :footer="isFooter"
    class="fts-quick-view"
    :data-entry-view-load="(initiating || viewFormLoading || activityFormLoading) ? 'loading' : 'loaded'"
    @close="closeQuickView"
    v-if="show"
  >
    <!-- header -->
    <template #header>
      <!-- left -->
      <div class="loc-header__l">
        <!-- activity -->
        <template>
          <!-- activity -->
          <div class="loc-header-activity" v-if="selectedActivity && selectedActivity.name">
            <i
              class="loc-header-activity__icon"
              :class="selectedActivity.icon"
              v-if="selectedActivity.icon"
            ></i>
            <fts-moji
              :emoji="selectedActivity.emoji"
              :size="18"
              class="loc-header-activity__emoji"
              v-if="selectedActivity.emoji"
            />
            <div class="loc-header-activity__name">
              {{ selectedActivity.name }}
            </div>
          </div>
        </template>
        <!-- header entry info -->
        <div
          class="loc-header-info"
          v-if="headerId || (module && module.name)"
        >
          <div class="loc-header-info__uppr">
            <!-- title -->
            <div class="loc-header-info-title" v-if="!isError && formTitle">
              {{ formTitle }}
            </div>
            <!-- module -->
            <div class="loc-header-info-module" v-if="module && module.id && module.name">
              <fts-moji
                :emoji="module.emoji"
                :size="18"
                class="loc-header-info-module__emoji"
                v-if="module.emoji"
              />
              <div class="loc-header-info-module__name">
                {{module.name}}
              </div>
            </div>
          </div>
          <div class="loc-header-info__lowr" v-if="headerId">
            <template v-if="multiple">
              <div class="loc-header-info-ids">{{ selectedItemsEtc }}</div>
              <div
                class="loc-header-info-ids__action"
                @click="showMultipleTable = !showMultipleTable"
              >
                {{ showMultipleTable ? "hide" : "show" }} details
              </div>
            </template>
            <template v-else>
              <!-- document -->
              <div class="loc-header-info-document__id">
                {{ header.documentId }}
              </div>
              <!-- audit -->
              <fts-tippy
                :options="{ placement: 'bottom-start' }" 
                append-trigger-class="audit-group__trigger" 
                append-content-class="audit-group__content" 
                class="fts-audit-group" 
                v-if="header && header.audit"
              >
                <template>
                  <fts-profile :user-name="header.audit.updatedBy" />
                  <div class="audit-group-date">
                    {{moment(header.audit.updatedDate).fromNow()}}
                  </div>
                </template>

                <template slot="content">
                  <fts-profile :profilePhotoSize="26" :user-name="header.audit.updatedBy" class="audit-group-wrapper">
                    <div slot="profileName" slot-scope="{ userProfileName }" class="audit-group-info">
                      <div>{{userProfileName}}</div>
                      <div class="audit-group-date">updated on {{moment(header.audit.updatedDate).format('llll')}}</div>
                    </div>
                  </fts-profile>

                  <fts-profile :profilePhotoSize="26" :user-name="header.audit.createdBy" class="audit-group-wrapper">
                    <div slot="profileName" slot-scope="{ userProfileName }" class="audit-group-info">
                      <div>{{userProfileName}}</div>
                      <div class="audit-group-date">created on {{moment(header.audit.createdDate).format('llll')}}</div>
                    </div>
                  </fts-profile>
                </template>
              </fts-tippy>
              <!-- assignee -->
              <fts-assign-to
                :module-id="vectorId"
                :form-data="{assignees: header.assignees, due: header.due}"
                view-mode
                :comment-section="false"
                v-if="header.assignees"
              />
            </template>
          </div>
        </div>
      </div>
      <!-- right -->
      <div class="loc-header__r">
        <!-- form sync -->
        <fts-form-sync
          :synchronize="$refs.classification.synchronize"
          class="loc-header-item"
          v-if="
            selectedActivity &&
            !(['assign', 'changeStatus', 'duplicate', 'delete'].indexOf(selectedActivity.id) > -1) &&
            $refs.classification
          "
        />
        <!-- state -->
        <fts-state
          :state="header.state"
          :states="states"
          class="loc-header-state loc-header-item"
          v-if="header && header.state && header.state.name && !multiple"
        />
        <template v-if="header && !isError">
          <!-- design -->
          <fts-tippy content="Design" v-if="!workspaceBuilder && isAdminUser && !builderMode && designRoute">
            <router-link :to="designRoute" v-slot="{ href }">
              <fts-btn
                tag="a"
                text
                icon
                color="secondary"
                box-shadow-none
                :href="href"
              >
                <font-awesome-icon :icon="['fas', 'wand-magic-sparkles']" />
              </fts-btn>
            </router-link>
          </fts-tippy>
          <!-- share -->
          <fts-dropdown-select
            append-to-body
            placement="bottom-end"
            append-content-class="loc-activity-dropdown-menu"
            prevent-overflow-alt-axis
            prevent-overflow-tether-off
            @selected="executeShare"
            v-if="!multiple && isShareable"
          >
            <fts-tippy content="Share" slot="toggle">
              <fts-btn text icon>
                <font-awesome-icon :icon="['fas', 'share-alt']" />
              </fts-btn>
            </fts-tippy>
            <!-- menu -->
            <template #menu="{ select, defaultOptionClass}">
              <!-- link -->
              <div
                :class="[defaultOptionClass, 'loc-activity-option']"
                @click="select('link')"
              >
                <font-awesome-icon :icon="['far', 'clone']" fixed-width class="loc-activity-option__icon" />
                <div>Copy link</div>
              </div>
              <template v-if="Boolean((selectedActivity && selectedActivity.share) || !selectedActivity)">
                <!-- share -->
                <div
                  :class="[defaultOptionClass, 'loc-activity-option']"
                  @click="select('share')"
                >
                  <font-awesome-icon :icon="['far', 'share-from-square']" fixed-width class="loc-activity-option__icon" />
                  <div>Share form</div>
                </div>
                <!-- embed -->
                <div
                  :class="[defaultOptionClass, 'loc-activity-option']"
                  @click="select('embed')"
                  v-if="isInternal"
                >
                  <font-awesome-icon :icon="['fas', 'code']" fixed-width class="loc-activity-option__icon" />
                  <div>Embed form <fts-release-badge alpha class="fts-align-top" /></div>
                </div>
              </template>
            </template>
          </fts-dropdown-select>
          <!-- basket -->
          <fts-basket
            mode="put"
            @addToForm="addToForm"
            class="lv-nav-action"
            v-if="entry !== 'view'"
          />
          <!-- history -->
          <div :class="{ 'history-count-wrapper': header.commentCount }" v-if="headerId && !multiple && hasHistoryRights">
            <fts-tippy :content="isCommentable ? 'Comment' : 'History'">
              <fts-btn
                text
                icon
                :color="header.commentCount ? 'primary' : 'gray-light'"
                @click="toggleHistory"
              >
                <font-awesome-icon :icon="['far', 'comment-alt']" />
              </fts-btn>
            </fts-tippy>
            <div class="history-count" v-if="header.commentCount">
              {{ header.commentCount }}
            </div>
          </div>
          <!-- actions -->
          <fts-tippy content="Actions" v-if="!initiating && !selectedActivity">
            <fts-dropdown-select
              append-to-body
              placement="bottom-end"
              prevent-overflow-alt-axis
              prevent-overflow-tether-off
              append-content-class="loc-activity-dropdown-menu"
              :options="sidebarActions"
              @selected="(x) => execute(x, x.actionType)"
            >
              <fts-btn slot="toggle" text icon :disabled="viewFormLoading">
                <font-awesome-icon :icon="['fas', 'ellipsis-v']" />
              </fts-btn>

              <fts-tippy
                slot="option"
                slot-scope="{ option, select, defaultClass }"
                :append-trigger-class="`${defaultClass} loc-activity-option loc-activity-option--secondary`"
                :content="option.tooltip"
                @trigger:click="select(option)"
                v-if="option.actionType === 'standard' && option.id == 'manage'"
              >
                <template>
                  <i class="loc-activity-option__icon" :class="option.icon"></i>
                  <div class="loc-activity-option__name">{{ option.name }}</div>
                </template>
              </fts-tippy>

              <div
                slot="option"
                slot-scope="{ option, select, defaultClass }"
                :class="`${defaultClass} loc-activity-option`"
                @click="select(option)"
                v-else
              >
                <!-- standard activity -->
                <template v-if="option.actionType === 'standard'">
                  <i class="loc-activity-option__icon" :class="option.icon"></i>
                  <div class="loc-activity-option__name">{{ option.name }}</div>
                </template>
                <!-- document -->
                <template v-else-if="option.actionType === 'template'">
                  <font-awesome-icon :icon="['far', 'file-pdf']" class="loc-activity-option__icon fts-file-pdf" v-if="option.typeId === 'pdf'" />
                  <font-awesome-icon :icon="['far', 'file-alt']" class="loc-activity-option__icon fts-file-excel" v-else-if="option.typeId === 'spreadsheet'" />
                  <font-awesome-icon :icon="['far', 'file-code']" class="loc-activity-option__icon fts-file-html" v-else-if="option.typeId === 'html'" />
                  <font-awesome-icon :icon="['far', 'file']" class="loc-activity-option__icon fts-file-default" v-else />
                  <div class="loc-activity-option__name">{{ option.name }}</div>
                </template>
                <!-- activity/action -->
                <template v-else>
                  <fts-moji
                    :emoji="option.emoji"
                    :size="14"
                    class="loc-activity-option__emoji"
                    v-if="option.emoji"
                  />
                  <div
                    class="loc-activity-option__name"
                    :style="{color: option.color}"
                  >
                    {{ option.name }}
                  </div>
                </template>
              </div>
            </fts-dropdown-select>
          </fts-tippy>
          <!-- expand/collapse -->
          <fts-tippy
            :option="{ placement: 'bottom' }"
            :content="`Switch to ${fullView ? 'compact' : 'immersive'} view`"
            v-if="!!selectedActivity || (isViewRight && isQuickViewRight)"
          >
            <fts-btn
              slot="trigger"
              text
              icon
              :disabled="viewFormLoading && !selectedActivity"
              @click="toggleView"
            >
              <font-awesome-icon
                :icon="['fas', 'compress-alt']"
                v-if="fullView"
              />
              <font-awesome-icon
                :icon="['fas', 'expand-alt']"
                v-else
              />
            </fts-btn>
          </fts-tippy>
        </template>
        <!-- close -->
        <fts-tippy content="Close">
          <fts-btn text icon @click="closeQuickView">
            <font-awesome-icon :icon="['fas', 'times']" />
          </fts-btn>
        </fts-tippy>
      </div>
    </template>
    <!-- body -->
    <template #body>
      <div class="quick-view-content lv-body">
        <div class="quick-view-form fts-scrollbar">
          <div class="quick-view-form__body">
            <!-- form switcher -->
            <div
              class="lv-form-switcher"
              v-if="
                selectedActivity &&
                selectedActivity.id != 'create' &&
                !multiple &&
                !activityFormLoading &&
                !isError
              "
            >
              <fts-btn
                text
                text-transform-init
                class="fts-font-normal"
                :loading="viewFormLoading"
                @click="showDetails"
              >
                {{showEntryDetails ? 'hide' : 'show'}} details
              </fts-btn>
            </div>
            <!-- multiple -->
            <fts-transition-expand>
              <div class="quick-view-entries lv-entries" v-if="showMultipleTable">
                <table class="fts-table">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Title</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in items" :key="item.id">
                      <td>{{ item.documentId }}</td>
                      <td>{{ item.title }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </fts-transition-expand>
            <!-- view -->
            <fts-transition-expand>
              <!-- error -->
              <div class="error-wrapper" v-if="isViewFormError && showEntryDetails">
                <div class="error-icon">
                  <font-awesome-icon :icon="['fas', 'times']" fixed-width />
                </div>
                <div class="error-title">Something went wrong</div>
                <div class="error-description">
                  {{viewFormError}}.
                  <template v-if="!fullView">
                    Click <span class="fts-link-primary" @click="toggleView">here</span> to try again.
                  </template>
                </div>
              </div>
              <!-- classification -->
              <fts-classification
                class="content-body-classification"
                :locusId="formData.id"
                :vectorId="vectorId"
                :users="users"
                :comment="comment"
                :viewData="viewData"
                :view="true"
                :username="username"
                :form-settings="{
                  tableStickyHeader: true
                }"
                v-else-if="viewData && showEntryDetails"
              />
            </fts-transition-expand>
            <!-- seperator -->  
            <fts-transition-fade>
              <div class="lv-form-separator" v-if="selectedActivity && selectedActivity.id && showEntryDetails">
                <div class="form-separator-title" v-if="selectedActivity.standard">
                  <i class="form-seperator-icon" :class="selectedActivity.icon" v-if="selectedActivity.icon"></i>
                  <div class="form-seperator-name">{{selectedActivity.name}}</div>
                </div>
                <div class="form-separator-title" v-else>
                  <fts-moji
                    :emoji="selectedActivity.emoji"
                    :size="18"
                    class="form-seperator-emoji"
                    v-if="selectedActivity.emoji" />
                  <div class="form-seperator-name">{{selectedActivity.name}}</div>
                </div>
              </div>
            </fts-transition-fade>
            <!-- activity -->
            <fts-transition-expand>
              <!-- error -->
              <div class="error-wrapper" v-if="isActivityFormError">
                <div class="error-icon">
                  <font-awesome-icon :icon="['fas', 'times']" fixed-width />
                </div>
                <div class="error-title">Something went wrong</div>
                <div class="error-description">{{activityFormError}}</div>
              </div>
              <!-- classification -->
              <fts-classification
                :key="selectedActivity.id"
                :users="users"
                :username="username"
                :locus-id="locusIds[0]"
                :vector-id="vectorId"
                :activity="selectedActivity.name"
                :activity-id="selectedActivity.id"
                :view="!isCapableOf(SYSTEM_CAPABILITY.Write)"
                :form-settings="{
                  tableStickyHeader: true,
                  tableStickyOffset: getTableStickyOffset()
                }"
                :comment="comment"
                :comment-section="isCommentable"
                :submitting.sync="submitting"
                :loading="activityFormLoading"
                class="content-body-classification"
                ref="classification"
                @cancel="cancel"
                @submit="submit"
                v-else-if="
                  selectedActivity &&
                  !(['assign', 'changeStatus', 'duplicate', 'delete'].indexOf(selectedActivity.id) > -1)
                "
              />
              <!-- standard activity -->
              <div class="standard-activity-form" v-else-if="selectedActivity && !activityFormLoading">
                <div class="standard-activity-form-content">
                  <!-- delete -->
                  <div
                    class="standard-activity-form-title"
                    v-if="selectedActivity.id === 'delete'"
                  >
                    Are you sure to delete?
                  </div>
                  <!-- duplicate -->
                  <div
                    class="standard-activity-form-title"
                    v-else-if="selectedActivity.id === 'duplicate'"
                  >
                    Are you sure to duplicate?
                  </div>
                  <!-- change state -->
                  <div class="standard-activity-state" v-else-if="selectedActivity.id === 'changeStatus'">
                    <div class="state-label-wrapper">
                      <div class="state-label">
                        Changing state to
                      </div>  
                      <div class="state-error" v-if="validationError()">{{validationError()}}</div>
                    </div>
                    <fts-dropdown-select
                      append-to-body
                      prevent-overflow-alt-axis
                      prevent-overflow-tether-off
                      v-model="selectedState"
                      :options="states"
                      class="state-dropdown"
                    >
                      <fts-state
                        slot="toggle"
                        slot-scope="{ selectedOption }"
                        :state="
                          selectedOption && selectedOption.name
                            ? selectedOption
                            : { name: 'select state' }
                        "
                        :states="states"
                      />
                      <div
                        slot="option"
                        slot-scope="{ option, select, defaultClass }"
                        :class="defaultClass"
                        @click="select(option)"
                      >
                        <fts-state :state="option" />
                      </div>
                    </fts-dropdown-select>    
                  </div>
                  <!-- assign -->
                  <fts-assign
                    :assign-data="formData"
                    v-else-if="selectedActivity.id === 'assign'"
                  />
                </div>
                <!-- standard activity comment -->
                <fts-comment
                  class="standard-activity-comment"
                  :vector-id="vectorId"
                  :comment="comment"
                  v-if="isCommentable && selectedActivity.id != 'duplicate'"
                />
              </div>
            </fts-transition-expand>
          </div>

          <fts-form-footer
            :activity="selectedActivity"
            :sync-state="$refs.classification && $refs.classification.syncState"
            :loading="$refs.classification && $refs.classification.isFormLoading"
            :submitting="submitting"
            :enable-continuable-create="!$route.query.dialog"
            class="quick-view-form__footer"
            @synchronize="evt => ($refs.classification && $refs.classification.synchronize(evt))"
            @sync:submit="$refs.classification && $refs.classification.submit()"
            @submit="submit"
            @cancel="cancel"
            v-if="selectedActivity && !activityFormLoading && !isError"
            ref="formFooter"
          />
        </div>

        <fts-spinner
          class="quick-view-form-spinner"
          v-if="
            initiating ||
            (viewFormLoading && !selectedActivity) ||
            activityFormLoading
          "
        />
      </div>
      <!-- full view activities, actions -->
      <div
        class="quick-view-fab"
        v-if="
          fullView &&
          selectedActivity == null &&
          !viewFormLoading &&
          !isError
        "
      >
        <div class="quick-view-fab-wrapper">
          <!-- single activity -->
          <fts-btn
            :color="executableActivity.color || 'primary'"
            outline
            text-transform-init
            :emoji="executableActivity.emoji"
            class="btn-activity quick-view-fab--single"
            @click="execute(executableActivity, 'activity')"
            v-if="executableActivity"
          >
            <span class="btn-activity-label">{{executableActivity.name}}</span>
          </fts-btn>
          <!-- Executable List -->
          <fts-dropdown-select
            append-to-body
            placement="top-end"
            prevent-overflow-alt-axis
            prevent-overflow-tether-off
            append-content-class="loc-activity-dropdown-menu"
            :options="sidebarActions"
            @selected="(x) => execute(x, x.actionType)"
            v-else
          >
            <fts-btn slot="toggle" color="primary"> Activity </fts-btn>
            <div
              slot="option"
              slot-scope="{ option, select, defaultClass }"
              :class="`${defaultClass} loc-activity-option`"
              @click="select(option)"
            >
              <!-- standard activity -->
              <template v-if="option.actionType === 'standard'">
                <i class="loc-activity-option__icon" :class="option.icon"></i>
                <div class="loc-activity-option__name">{{ option.name }}</div>
              </template>
              <!-- document -->
              <template v-else-if="option.actionType === 'template'">
                <font-awesome-icon :icon="['far', 'file-pdf']" class="loc-activity-option__icon fts-file-pdf" v-if="option.typeId === 'pdf'" />
                <font-awesome-icon :icon="['far', 'file-alt']" class="loc-activity-option__icon fts-file-excel" v-else-if="option.typeId === 'spreadsheet'" />
                <font-awesome-icon :icon="['far', 'file-code']" class="loc-activity-option__icon fts-file-html" v-else-if="option.typeId === 'html'" />
                <font-awesome-icon :icon="['far', 'file']" class="loc-activity-option__icon fts-file-default" v-else />
                <div class="loc-activity-option__name">{{ option.name }}
                  <fts-test-badge v-if="option.development" :stage="option.development"></fts-test-badge>
                </div>
              </template>
              <!-- activity/action -->
              <template v-else>
                <fts-moji
                  :emoji="option.emoji"
                  :size="14"
                  class="loc-activity-option__emoji"
                  v-if="option.emoji"
                />
                <div
                  class="loc-activity-option__name"
                  :style="{color: option.color}"
                >
                  {{ option.name }}
                  <fts-test-badge v-if="option.development" :stage="option.development"></fts-test-badge>
                </div>
              </template>
            </div>
          </fts-dropdown-select>
        </div>
      </div>
      <!-- history -->
      <fts-history
        :locus-id="headerId"
        :vector-id="vectorId"
        :states="states"
        :users="users"
        :comment-section="isCommentable"
        :init-open="Boolean(header.commentCount && header.commentCount > 0)"
        @added="historyAdded"
        ref="ftsHistory"
        v-if="!initiating && !multiple && !isError && headerId && hasHistoryRights"
      />

      <fts-action-page-modal ref="ftsActionPageModal" />
      <fts-embed-form-modal ref="ftsEmbedFormModal" />
      <fts-document-form-modal ref="ftsDocumentFormModal" />
      <fts-form-message-modal ref="ftsFormMessageModal" />
      <fts-share-form-modal ref="ftsShareFormModal" />
    </template>
    <!-- footer -->
    <template #footer>
      <!-- progress -->
      <div v-if="progress">
        <span>Progress: {{ progress }}</span>
      </div>
      <!-- footer (activity, document, custom) -->
      <div class="footer-action" v-if="!viewFormLoading && !selectedActivity && footer">
        <div class="fts-list-view-action" >
          <!-- activity -->
          <fts-btn
            v-for="activity in footer.activities"
            :key="activity.id"
            outline
            :color="activity.color || 'primary'"
            :emoji="activity.emoji"
            text-transform-init
            class="btn-activity"
            @click="execute(activity, 'activity')">
            <span class="btn-activity-label">{{activity.name}}
              <fts-test-badge v-if="activity.development" :stage="activity.development"></fts-test-badge>
            </span>
          </fts-btn>
          <!-- documents -->
          <fts-btn
            outline
            color="ternary-green"
            text-transform-init
            class="btn-activity"
            v-for="action in footer.documents"
            :key="action.id"
            @click="execute(action, 'document')">
            <font-awesome-icon :icon="['far', 'file-pdf']" class="btn-activity-icon fts-file-pdf" v-if="action.typeId === 'pdf'" />
            <font-awesome-icon :icon="['far', 'file-alt']" class="btn-activity-icon fts-file-excel" v-else-if="action.typeId === 'spreadsheet'" />
            <font-awesome-icon :icon="['far', 'file-code']" class="btn-activity-icon fts-file-html" v-else-if="action.typeId === 'html'" />
            <font-awesome-icon :icon="['far', 'file']" class="btn-activity-icon fts-file-default" v-else />
            <span class="btn-activity-label">{{action.name}}
              <fts-test-badge v-if="action.development" :stage="action.development"></fts-test-badge>
            </span>
          </fts-btn>
          <!-- custom -->
          <fts-btn
            outline
            :color="action.color || 'ternary-blue'"
            :emoji="action.emoji"
            text-transform-init
            class="btn-activity"
            v-for="action in footer.customs"
            :key="action.id"
            @click="execute(action, 'custom')">
            <span :class="{'btn-activity-label': !action.color}">{{action.name}}</span>
          </fts-btn>
        </div>
      </div>
    </template>
  </fts-modal>
</template>

<script>
import Vue from 'vue';
import Vuelidate from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
Vue.use(Vuelidate);

import moment from 'moment';
import firebase from 'firebase/app';
import 'firebase/analytics';

import { authorizationStore } from '../../store/authorizationStore';
import { classificationStore } from '../../store/classificationStore';
import { clientStore } from '../../store/clientStore';
import commons from '../../commons/commons';
import confetti from '../../commons/confetti';
import { SYSTEM_CAPABILITY, isCapableOf } from '../../commons/flags';

import FTSActionPageModal from '../FTSActionPageModal';
import FTSAssign from '../FTSAssign';
import FTSAssignTo from '../FTSAssignTo';
import FTSBasket from '../FTSBasket';
import FTSBtn from '../FTSBtn';
import FTSBtnHold from '../FTSBtnHold';
import FTSClassification from '../FTSClassification';
import FTSComment from '../FTSComment';
import FTSDocumentFormModal from '../FTSDocumentFormModal';
import FTSDropdownSelect from '../FTSDropdownSelect';
import FTSEmbedFormModal from '../FTSEmbedFormModal';
import FTSFormFooter from '../form/FTSFormFooter';
import FTSFormMessageModal from '../form/FTSFormMessageModal';
import FTSFormSync from '../form/FTSFormSync';
import FTSHistory from '../history/FTSHistory';
import FTSModal from '../FTSModal';
import FTSMoji from '../FTSMoji';
import FTSProfile from '../FTSProfile';
import FTSShareFormModal from '../FTSShareFormModal';
import FTSSpinner from '../FTSSpinner';
import FTSState from '../FTSState';
import FTSTippy from '../FTSTippy';
import FTSTransitionExpand from '../FTSTransitionExpand';
import FTSTransitionFade from '../transition/FTSTransitionFade';
import FTSTestBadge from '../FTSTestBadge.vue';

const MODULE_UNAVAILABLE_MESSAGE = "Module you trying to access is unpublished or have been removed.";
const ENTRY_UNAVAILABLE_MESSAGE = "Entry you trying to access is not available. Please check with your administrator.";
const ACTIVITY_UNAVAILABLE_MESSAGE = "Entry not able to perform this activity. Please check with your administrator";
const CAPABILITY_UNAVAILABLE_MESSAGE = "401 Unauthorized. Access denied due to invalid credentials.";

const getSuccessMessage = (id, standard) => {
  if (standard) {
    if (id === 'create')
      return 'Successfully created';
    else if (id == 'edit')
      return 'Successfully updated';
    else if (id === 'delete')
      return 'Successfully deleted';
    else if (id === 'duplicate')
      return 'Successfully duplicated';
    else if (id === 'assign')
      return 'Successfully assigned';
  }
  return 'Submission successful';
}
const getErrorMessage = (id, standard) => {
  if (standard) {
    if (id === 'create')
      return 'Failed to create';
    else if (id === 'edit')
      return 'Failed to update';
    else if (id === 'delete')
      return 'Failed to delete';
    else if (id === 'duplicate')
      return 'Failed to duplicate'; 
    else if (id === 'assign')
      return 'Failed to assign';
  }
  return 'Submission failed';
}

export default {
  components: {
    "fts-action-page-modal": FTSActionPageModal,
    "fts-assign": FTSAssign,
    "fts-assign-to": FTSAssignTo,
    "fts-basket": FTSBasket,
    "fts-btn": FTSBtn,
    "fts-btn-hold": FTSBtnHold,
    "fts-classification": FTSClassification,
    "fts-comment": FTSComment,
    "fts-document-form-modal": FTSDocumentFormModal,
    "fts-dropdown-select": FTSDropdownSelect,
    "fts-embed-form-modal": FTSEmbedFormModal,
    "fts-form-footer": FTSFormFooter,
    "fts-form-message-modal": FTSFormMessageModal,
    "fts-form-sync": FTSFormSync,
    "fts-history": FTSHistory,
    "fts-modal": FTSModal,
    "fts-moji": FTSMoji,
    "fts-profile": FTSProfile,
    "fts-share-form-modal": FTSShareFormModal,
    "fts-spinner": FTSSpinner,
    "fts-state": FTSState,
    "fts-tippy": FTSTippy,
    "fts-transition-expand": FTSTransitionExpand,
    "fts-transition-fade": FTSTransitionFade,
    "fts-test-badge": FTSTestBadge
  },
  data: () => ({
    SYSTEM_CAPABILITY: Object.freeze(SYSTEM_CAPABILITY),
    show: false,
    formData: {},
    vectorId: null,
    listingId: null,
    entry: null,
    header: {},
    footer: {},
    viewData: null,
    items: [],
    username: null,
    comment: {},
    selectedActivity: null,
    selectedState: {},
    progress: null,
    refreshList: false,
    initiating: false,
    submitting: false,
    viewFormLoading: false,
    activityFormLoading: false,
    /* view */
    fullView: false,
    showEntryDetails: false,
    /* entries */
    showMultipleTable: false,
    /* error handling */
    isViewFormError: false,
    viewFormError: null,
    isActivityFormError: false,
    activityFormError: null,
    /* undefined */
    activity: {},
  }),
  validations() {
    let selectedState = {};
    if (this.selectedActivity && this.selectedActivity.id === 'changeStatus') {
      selectedState = {
        name: { required }
      }
    }
    return { selectedState };
  },
  methods: {
    moment,
    isCapableOf(type) {
      return isCapableOf(type, clientStore.state.workspaceModules, this.vectorId);
    },
    async loadViewForm() {
      this.header = {...this.header, id: this.locusIds[0] };
      try {
        let vm = this;
        vm.viewFormLoading = true;
        vm.showEntryDetails = true;
        vm.isViewFormError = false;
        /* capability */
        if (!vm.isCapableOf(SYSTEM_CAPABILITY.Read)) {
          throw { response: { data: { message: CAPABILITY_UNAVAILABLE_MESSAGE}, status: 400}};
        }
        /* dispatch */
        let viewResult = await classificationStore.dispatch("loadViewForm", {
          moduleId: vm.vectorId? vm.vectorId.toString() : null,
          listingId: vm.listingId,
          activityId: vm.fullView ? "view" : "quickView",
          entryId: vm.header.id,
          locusId: vm.header.id, /* to-do delete */
          query: vm.$route.query,
          users: vm.users
        });
        /* entry not matched */
        if (vm.header.id != viewResult.header.entryId) {
          console.warn("Load view form aborted; entry not matched.");
          return;
        }
        /* set */
        vm.header = viewResult.header;
        vm.footer = viewResult.footer;
        vm.$set(vm.items, 0, {
          ...vm.header,
          extension: {...viewResult.viewData && viewResult.viewData.formData}
        });
        /* vector */
        if (vm.header && vm.header.moduleId && vm.header.moduleId != vm.vectorId) {
          vm.vectorId = vm.header.moduleId;
          vm.setRouter();
        }
        // standards
        let excludedStandards = [];

        if (!vm.isCapableOf(SYSTEM_CAPABILITY.Write)) {
          excludedStandards.push(...["create", "edit", "changeStatus", "duplicate", "assign"]);
        }

        if (!vm.isCapableOf(SYSTEM_CAPABILITY.Delete)) {
          excludedStandards.push("delete");
        }

        if (!vm.isCapableOf(SYSTEM_CAPABILITY.Read)) {
          excludedStandards.push(...["view", "quickView"]);
        }

        vm.footer.standards = vm.footer.standards.filter(x => !excludedStandards.includes(x));
        vm.viewData = viewResult.viewData;
        /* custom visibility */
        if (vm.footer && vm.footer.customs && vm.footer.customs.length) {
          vm.footer.customs = commons.getFormAvailableCustoms(vm.footer.customs, vm.items);
        }
        /* analytics */
        if (vm.module) {
          firebase.analytics().logEvent("screen_view", {
            screen_name: `${vm.header.documentId}|${vm.module.name}`,
          });
        } else {
          try {
            await clientStore.dispatch('loadWorkspaceModule', {
              moduleId: viewResult.header.moduleId,
            });
            if (!vm.module) throw "Error: module is not defined";
          } catch(loadWorkspaceModuleError) {
            console.error("QuickView:ViewForm", loadWorkspaceModuleError);
            throw { response: { data: { message: MODULE_UNAVAILABLE_MESSAGE}, status: 400}};
          }
        }
      } catch(err) {
        console.error("QuickView:ViewForm", err);
        this.isViewFormError = true;
        this.viewFormError = ENTRY_UNAVAILABLE_MESSAGE;
        if (
          err.response &&
          err.response.status === 400 &&
          err.response.data &&
          err.response.data.message
        ) {
          this.viewFormError = err.response.data.message;
        }
      } finally {
        this.viewFormLoading = false;
      }
    },
    async loadActivityForm() {
      try {
        let vm = this;
        vm.activityFormLoading = true;
        vm.showEntryDetails = false;
        vm.isActivityFormError = false;
        // entry manage
        if (vm.selectedActivity.id === "manage" && !vm.isAdminUser) {
          throw { response: { data: { message: ACTIVITY_UNAVAILABLE_MESSAGE}, status: 400}};
        }
        // capability
        if (
          (
            vm.selectedActivity.id === "delete" && !vm.isCapableOf(SYSTEM_CAPABILITY.Delete)
          ) || (
            ["create", "edit", "changeStatus", "duplicate", "assign"].indexOf(vm.selectedActivity.id) > -1 &&
            !vm.isCapableOf(SYSTEM_CAPABILITY.Write)
          )
        ) {
          throw { response: { data: { message: CAPABILITY_UNAVAILABLE_MESSAGE}, status: 400}};
        }

        const setForm = (result) => {
          vm.header = result.header;
          vm.footer = result.footer;
          // vector
          if (result.header && result.header.moduleId) {
            vm.vectorId = result.header.moduleId;
          }
          // activity
          if (result.header && result.header.activity) {
            vm.selectedActivity = result.header.activity;
            vm.selectedActivity.share = true;
          }
          // form sync
          if (result.needSync && vm.selectedActivity) {
            vm.$refs.classification.pollData(vm.selectedActivity);
          }
          // assign data
          if (vm.selectedActivity.id === "assign" && vm.header) {
            vm.header.assignees && vm.$set(vm.formData, "assignees", vm.header.assignees);
            vm.header.due && vm.$set(vm.formData, "due", vm.header.due);
          } else {
            vm.$delete(vm.formData, "assignees");
            vm.$delete(vm.formData, "due");
          }
          // analytic
          if (vm.module) {
            firebase.analytics().logEvent("screen_view", {
              screen_name: `${vm.selectedActivity.name}|${vm.header.documentId}|${vm.module.name}`,
            });
          } else {
            throw { response: { data: { message: MODULE_UNAVAILABLE_MESSAGE}, status: 400}};
          }
        }

        let payload = {
          moduleId: vm.vectorId? vm.vectorId.toString() : null,
          listingId: vm.listingId,
          activityId: vm.selectedActivity.id,
          entryId: vm.locusIds[0],
          locusId: vm.locusIds[0], /* to-do delete */
          query: vm.$route.query,
          users: vm.users,
          enableCache: true,
          hasCache: false
        };
        
        if (vm.selectedActivity.id == "create") {
          const cachedForm = classificationStore.getters.getCachedForm({
            moduleId: vm.vectorId,
            activityId: vm.selectedActivity.id
          });
          if (cachedForm) {
            classificationStore.dispatch("loadActivityFormCache", {
              setup: payload,
              data: cachedForm
            });
            setForm(cachedForm);
            payload.hasCache = true;
          }
        }

        if (payload.hasCache) {
          vm.activityFormLoading = false;
          vm.initiating = false;
        }

        let result = await classificationStore.dispatch("loadActivityForm", payload);
        setForm(result);

        if (result.needCache) {
          classificationStore.dispatch("setCachedForm", {
            moduleId: vm.vectorId,
            activityId: vm.selectedActivity.id,
            data: result
          });
        } else {
          classificationStore.dispatch("clearCachedForm", {
            moduleId: vm.vectorId,
            activityId: vm.selectedActivity.id
          });
        }
      } catch(err) {
        console.error("QuickView:ActivityForm", err);
        this.isActivityFormError = true;
        this.activityFormError = ACTIVITY_UNAVAILABLE_MESSAGE;
        if (
          err.response &&
          err.response.status === 400 &&
          err.response.data &&
          err.response.data.message
        ) {
          this.activityFormError = err.response.data.message;
        }
      } finally {
        this.activityFormLoading = false;
      }
    },
    showDetails() {
      this.showEntryDetails = !this.showEntryDetails;
      if (this.showEntryDetails && this.viewData == null) {
        this.loadViewForm();
      }
    },
    addToForm(basketItems) {
      this.$refs.classification.addToForm(basketItems);
    },
    setRouter() {
      /* route only set when modal is opened */
      if (this.show && this.$route.name) {
        const routeQuery = (() => {
          let query = { ...this.$route.query };
          if (this.fullView)
            return { ...query, m: 'f' };
          else if (query.m === 'f')
            delete query.m;

          return query;
        })();
        const moduleId = this.header && this.header.moduleId ? this.header.moduleId : this.vectorId;
        const selectedActivityId = this.selectedActivity && this.selectedActivity.id;
        /* create */
        if (selectedActivityId === 'create') {   
          const routeParamsModuleId = this.$route && this.$route.params && this.$route.params.moduleId ? commons.decodeids(this.$route.params.moduleId) : null;
          if (Boolean(routeParamsModuleId) && commons.decodeids(routeParamsModuleId) == moduleId) {
            this.$router.push({
              query: { ...routeQuery, a: this.selectedActivity.id },
            });
          }
        } else if (this.headerId) {
          if (this.selectedActivity) {
            this.$router.push({
              query: {
                ...routeQuery,
                id: commons.queryEncodeids(moduleId, this.headerId),
                a: this.selectedActivity.id,
              },
            });
          } else {
            let query = {
              ...routeQuery,
              id: commons.queryEncodeids(moduleId, this.headerId),
            };
            if (query.hasOwnProperty("a")) delete query.a;
            this.$router.push({ query: query });
          }
        }
      }
    },
    async openQuickView() {
      this.show = true;
    },
    closeQuickView() {
      if (this.$route.query.dialog)
        window.close();

      this.show = false;

      let query = {};
      if (this.$route.query.l) query.l = this.$route.query.l;
      if (this.$route.query.t) query.t = this.$route.query.t;
      this.$router.push({ query: query });

      if (this.refreshList) {
        window.eventBus.$emit("entry:updated", {
          moduleId: this.vectorId
        });

        if (this.$route.name == "dashboard") {
          window.eventBus.$emit("dashboardRefresh");
        } else if (this.$route.name == "calendar") {
          window.eventBus.$emit("calendarRefresh");
        } else if (this.$route.meta && this.$route.meta.group == "users" && this.module.isProfile) {
          window.eventBus.$emit("users:refresh");
        }
      }

      this.$emit("closed");
    },
    toggleHistory() {
      this.$refs.ftsHistory.toggleHistory();
    },
    historyAdded() {
      this.refreshList = true;
      if (this.header.commentCount) this.header.commentCount += 1;
      else this.header.commentCount = 1;
    },
    async execute(x, type) {
      if (type == "activity" || type == "standard") {
        if (type == "activity" && x.id != "manage" && x.skipConfirm) {
          window.eventBus.$emit("formSkipConfirmation", {
            moduleId: this.module && this.module.id.toString(),
            activity: x,
            activityId: x.id,
            entryIds: this.items.map((y) => y.id),
          });
          this.closeQuickView();
        } else {
          this.selectedActivity = x;
          this.setRouter();
          this.loadActivityForm();
        }
      } else if (type == "custom") {
        commons.executeEntryCustom({
          action: x,
          items: this.items,
          modal: this.$refs.ftsActionPageModal
        });
      } else if (type == "document" || type == "template") {
        if (x.hasForm) {
          await this.$refs.ftsDocumentFormModal.show({
            moduleId: this.vectorId,
            listingId: this.listingId,
            document: x,
            items: this.items
          });
        } else {
          window.eventBus.$emit("showPDFDocument", {
            moduleId: this.vectorId,
            document: x,
            items: this.items
          });
        }
      } else {
        this.$emit("actionExecuted", { action: x, items: [this.formData] });
      }
    },
    async submit(formData) {
      this.$v.$touch();

      if (this.$v.$invalid) return;

      let vm = this;
      this.submitting = true;

      try {
        let result = await classificationStore.dispatch("submitActivity", {
          moduleId: (this.module && this.module.id)? this.module.id.toString() : null,
          activityId: this.selectedActivity.id,
          payload: formData,
          entryIds: this.items.map(x => x.id),
          post: this.comment,
          intention: this.comment.attention,
          state: this.selectedState ? this.selectedState.name : null,
          assignees: this.formData.assignees,
          due: this.formData.due ? moment(this.formData.due).endOf('day') : null,
          query: this.$route.query
        });
        this.submitting = false;
        this.refreshList = true;
        /* confetti */
        if (result.data.celebrate) {
          confetti();
        }
        /* message */
        if (result.data.message) {
          await this.$refs.ftsFormMessageModal.show(result.data.message);
        } else {
          this.$toasted.success(
            getSuccessMessage(this.selectedActivity.id, this.selectedActivity.standard)
          );
        }
        /* form ads */
        if (
          classificationStore.state.form &&
          classificationStore.state.form.ads
        ) {
          let entryId = result.data.id;
          try {
            eval(
              classificationStore.state.form &&
                classificationStore.state.form.ads
            );
          } catch (ex) {
            this.$toasted.error(ex);
          }
        }
        if (vm.$route.query.dialog) {
          window.opener.newAddedCallback({
            guid: vm.$route.query.dialog,
            id: result.data.entryId,
          });
          window.close();
        } else if (this.$refs.classification && this.$refs.formFooter && this.$refs.formFooter.isContinuableCreate) {
          this.$refs.classification.reset();
          this.comment = {};
        } else {
          this.closeQuickView();
        }
      } catch (err) {
        let message = getErrorMessage(this.selectedActivity.id, this.selectedActivity.standard);
        if (
          err.response
          && err.response.data
          && err.response.data.message
        ) {
          message = `${message}. ${err.response.data.message}`;
        }
        this.$toasted.error(message);
      } finally {
        this.submitting = false;
      }
    },
    cancel() {
      if (this.entry == "activity") {
        this.closeQuickView();
      } else {
        this.showEntryDetails = true;
        this.selectedActivity = null;
        if (this.fullView && !this.isViewRight) {
          this.fullView = !this.fullView;
        } else if (!this.fullView && !this.isQuickViewRight) {
          this.fullView = !this.fullView;
        }
        this.setRouter();
        this.loadViewForm(); 
      }
    },
    executeShare(item) {
      if (item === 'share') {
        this.$refs.ftsShareFormModal.show({
          id: this.headerId,
          moduleId: this.header.moduleId,
          activityId: this.selectedActivity? this.selectedActivity.id : 'view',
        });
      } else if (item == 'link') {
        try {
          const res = commons.entryCopyLink({
            moduleName: this.module && this.module.name,
            activityId: this.selectedActivity && this.selectedActivity.id,
            documentId: this.header && this.header.documentId,
            title: this.header && this.header.title
          });

        this.$toasted.success(res.message);  
        } catch (err) {
          this.$toasted.global.error(err);
        }
      } else if (item == 'embed') {
        this.$refs.ftsEmbedFormModal.show({
          id: this.headerId,
          moduleId: this.header.moduleId,
          activityId: this.selectedActivity? this.selectedActivity.id : 'view',
        });
      }
    },
    toggleView() {
      this.fullView = !this.fullView;
      /* route */
      const routeModuleId = commons.decodeids(this.$route.params.moduleId);
      if (this.$route.name && routeModuleId == this.header.moduleId) {
        if (this.fullView) {
          this.$router.replace({ query: { ...this.$route.query, m: "f" } });
        } else if (
          this.$route.query.m &&
          this.$route.query.m.toLowerCase() === "f"
        ) {
          let query = Object.assign({}, this.$route.query);
          delete query.m;
          this.$router.replace({ query: query });
        }
      }
      /* entry details */
      this.showEntryDetails && this.loadViewForm();
    },
    validationError() {
      if (this.$v.selectedState && this.$v.selectedState.$error) {
        return "State is required."
      }
    },
    getTableStickyOffset() {
      const formFooterEl = this.$refs.formFooter && this.$refs.formFooter.$el;
      if (formFooterEl) {
        const formFooterElHeight = formFooterEl.offsetHeight;
        if (formFooterElHeight) {
          return { bottom: formFooterElHeight };
        }
      }
    }
  },
  computed: {
    isDevelopment() {
      return authorizationStore.getters.isDevelopment;
    },
    isInternal() {
      return authorizationStore.getters.isInternal;
    },
    isAdminUser() {
      return authorizationStore.getters.isAdminUser;
    },
    isQuickViewRight() {
      return (
        this.footer &&
        this.footer.standards &&
        this.footer.standards.indexOf('quickView') > -1
      );
    },
    isViewRight() {
      return (
        this.footer &&
        this.footer.standards &&
        this.footer.standards.indexOf('view') > -1
      );
    },
    isCommentable() {
      return (
        this.footer &&
        this.footer.standards &&
        this.footer.standards.indexOf('comment') > -1
      );
    },
    hasHistoryRights() {
      return (
        this.footer &&
        this.footer.standards &&
        this.footer.standards.indexOf('history') > -1
      );
    },
    isShareable() {
      return (
        this.footer &&
        this.footer.standards &&
        this.footer.standards.indexOf('share') > -1
      );
    },
    isFooter() {
      return (
        !this.fullView && 
        !this.isError &&
        (
          (
            this.entry === 'view' && 
            !this.selectedActivity &&
            this.footer && (
              !!(this.footer.activities && this.footer.activities.length) || 
              !!(this.footer.customs && this.footer.customs.length) || 
              !!(this.footer.documents && this.footer.documents.length)
            )
          ) ||
          (
            this.selectedActivity &&
            ["assign", "changeStatus", "delete", "duplicate"].indexOf(this.selectedActivity.id) > -1
          ) ||
          this.progress
        )
      )
    },
    isError() {
      return (
        (!Boolean(this.selectedActivity) && this.isViewFormError)
        || (Boolean(this.selectedActivity) && this.isActivityFormError)
      );
    },
    isBackdrop() {
      return !this.selectedActivity;
    },
    workspaceBuilder() {
      return clientStore.getters.workspaceBuilder;
    },
    module() {
      return this.vectorId && clientStore.state.workspace.vectors.find(
        (x) => x.id == this.vectorId
      );
    },
    states() {
      return this.vectorId && clientStore.getters.workspaceStates.filter(
        (x) => x.module == this.vectorId.toString()
      );
    },
    users() {
      return clientStore.getters.workspaceUsers;
    },
    headerId() {
      return this.header && (this.header.id || this.header.entryId);
    },
    formTitle() {
      if (
        (this.selectedActivity && this.selectedActivity.id !== 'create') || 
        !this.selectedActivity
      ) {
        if (this.items && this.items.length > 1)
          return `${this.items.length} items selected`;
        else if (this.header && this.header.title)
          return this.header.title;
        else if (!(this.viewFormLoading || this.activityFormLoading))
          return "(untitled)";
      }
    },
    multiple() {
      return this.items && this.items.length > 1;
    },
    locusIds() {
      return this.items ? this.items.map((x) => x.id) : [];
    },
    selectedItemsEtc() {
      if (!this.items || this.items < 2) return "";
      else if (this.items.length == 2) {
        return `${this.items[0].documentId} and ${this.items[1].documentId}`;
      } else if (this.items.length == 3) {
        return `${this.items[0].documentId}, ${this.items[1].documentId} and ${this.items[2].documentId}`;
      } else {
        return `${this.items[0].documentId}, ${this.items[1].documentId} and ${
          this.items.length - 2
        } others`;
      }
    },
    executableActivity() {
      if (this.footer.activities && this.footer.activities.length === 1)
        return this.footer.activities[0];
    },
    sidebarActions() {
      let list = [];
      const addDivider = () => {
        Boolean(list.length) && list.push({
          "id": `action-divider-${list.length}`,
          "optionRole": "divider"
        });
      }
      if (this.footer) {
        if (this.footer.activities && this.footer.activities.length) {
          this.footer.activities.forEach((x) => (x.actionType = "activity"));
          list = list.concat(this.footer.activities);
        }
        if (this.footer.documents && this.footer.documents.length) {
          addDivider();
          this.footer.documents.forEach((x) => (x.actionType = "template"));
          list = list.concat(this.footer.documents);
        }
        if (this.footer.customs && this.footer.customs.length) {
          addDivider();
          this.footer.customs.forEach((x) => (x.actionType = "custom"));
          list = list.concat(this.footer.customs);
        }
        if (this.footer.standards && this.footer.standards.length) {
          let standards = commons.standardActivities.filter(
            (x) =>
              this.footer.standards.indexOf(x.id) > -1 &&
              x.id != "view" &&
              x.id != "create"
          );
          if (standards && standards.length) {
            addDivider();
            standards.forEach((x) => (x.actionType = "standard"));
            list = list.concat(standards);
          } 
        }

        if (this.isAdminUser) {
          const availableAdminFeatures = ["manage"];
          let adminFeatures = commons.adminFeatures.filter(x => availableAdminFeatures.includes(x.id));
          if (adminFeatures.length) {
            if (list.every(x => x.actionType !== "standard")) {
              addDivider();
            }

            adminFeatures.forEach(x => (x.actionType = "standard"));
            list = list.concat(adminFeatures);
          }
        }
      }
      return list;
    },
    designRoute() {
      if (this.module && this.module.id) {
        return this.selectedActivity && this.selectedActivity.id ?
          commons.studioRoute({
            moduleId: this.module.id,
            type: this.selectedActivity.standard ? 'standardActivity' : 'activity',
            typeId: this.selectedActivity.id
          }) :
          commons.studioRoute({
            moduleId: this.module.id,
            type: 'standardActivity',
            typeId: this.fullView ? 'view' : 'quickView'
          });
      }
    }
  },
  created() {
    this.builderMode = commons.builderMode;
  },
  async mounted() {
    let vm = this;
    /* open quick view */
    window.eventBus.$on("quickViewData", async (res) => {
      if ((res.fromUrl && vm.show) || vm.show) {
        var current = {
          id: vm.header ? vm.headerId : null,
          activityId: vm.selectedActivity ? vm.selectedActivity.id : null,
          vectorId: vm.vectorId,
          fullView: vm.fullView,
        };

        if (
          res.id == current.id &&
          res.activityId == current.activityId &&
          (!res.vectorId || res.vectorId == current.vectorId)
        ) {
          if (Boolean(current.fullView) != Boolean(res.fullView)) {
            await vm.toggleView();
          }
          return;
        }
      }

      try {
        vm.initiating = true;
        classificationStore.dispatch("resetActivityForm");
        vm.username = res.username;
        vm.fullView = res.fullView;
        vm.vectorId = res.vectorId;
        vm.listingId = res.listingId;
        vm.openQuickView();

        if (
          res.activityId &&
          res.activityId != "view" &&
          res.activityId != "quickView"
        ) {
          vm.selectedActivity = res.activity;
          if (vm.selectedActivity == null) {
            vm.selectedActivity = commons.standardActivities.find((x) => x.id == res.activityId);
          }

          if (vm.selectedActivity == null) {
            vm.selectedActivity = commons.adminFeatures.find(x => x.id == res.activityId);
          }

          if (vm.selectedActivity == null) {
            vm.selectedActivity = { id: res.activityId };
          }

          vm.entry = "activity";
        } else {
          vm.selectedActivity = null;
          vm.entry = "view";
        }

        if (Array.isArray(res.items) && res.items.length) {
          vm.items = res.items;
          vm.header = res.items[0];
        } else if (res.id) {
          vm.items = [{id: res.id}];
          vm.header = {id: res.id}; 
          vm.formData = {id: res.id};
        } else {
          vm.header = null;
          vm.items = [];
        }

        if (vm.$route.name) {
          vm.setRouter(); 
        }
        
        if (vm.entry == "activity") {
          await vm.loadActivityForm();
          if (
            res.activityId == "create" && 
            vm.username &&
            classificationStore.state.formData
          ) {
            classificationStore.state.formData["username"] = vm.username;
          }
        } else {
          await vm.loadViewForm();
        }
      } catch(err) {
        console.error(err);
      } finally {
        vm.initiating = false;
      }
    });
    /* close quick view */
    window.eventBus.$on("closeQuickView", () => {
      if (this.show) {
        this.closeQuickView();
      }
    });
    // reset quick view
    window.eventBus.$on("quickView.reset", () => {
      if (this.show)
        Object.assign(this.$data, this.$options.data.apply(this));
    });
    /* activity process */
    window.eventBus.$on("activityProcess", (data) => {
      if (
        vm.formData &&
        vm.formData.id &&
        data.EntryId == vm.formData.id.toString()
      ) {
        vm.progress = `${data.Progress}/${data.Total}`;

        if (data.Progress == data.Total) {
          vm.progress = "";
        }
      }
    });
    /* load form */
    window.eventBus.$on("ftsQuickViewLoadForm", () => {
      if (this.selectedActivity) {
        this.loadActivityForm();
      } else {
        this.loadViewForm();
      }
    });
  },
  beforeDestroy() {
    window.eventBus.$off("quickViewData");
    window.eventBus.$off("closeQuickView");
    window.eventBus.$off("quickView.reset");
    window.eventBus.$off("activityProcess");
    window.eventBus.$off("ftsQuickViewLoadForm");
  },
};
</script>

<style lang="scss">
@use "/scss/style.scss";
@use "./src/assets/scss/vars.scss" as *;

.fts-quick-view {
  &:not(.full-modal) {
    > .fts-modal-wrapper {
      max-width: 1280px;
    }
    .fts-form-element:not(.fw) {
      min-width: 50%;
    }
  }
  >.fts-modal-wrapper {
    > .quick-view-modal-container {
      overflow: auto;
    }
  }
  .quick-view__header,
  .quick-view__content,
  .quick-view__footer {
    min-width: 900px;
  }
  .quick-view__content {
    display: flex;
    background-color: inherit;
  }
  .quick-view__footer {
    border-top: 1px solid var(--fts-border);
    .footer-action {
      padding: 0.75rem 1rem;
    }
    .footer-standard {
      padding: 1rem;
      text-align: right;
    }
  }
  .quick-view-content {
    position: relative;
    flex: 1;
    display: flex;
    flex-direction: column;
    background-color: inherit;
    overflow: hidden;
  }
  .quick-view-form {
    flex: 1;
    min-height: 150px;
    background-color: inherit;
  }
  .quick-view-form__body {
    padding: 1rem;
    &:not(:last-child) {
      padding-bottom: 0.5rem;
    }
  }
  .quick-view-form__footer {
    position: sticky;
    left: 0;
    bottom: 0;
    padding: 1rem;
    z-index: 2;
  }
  .quick-view-form-spinner {
    position: absolute;
    inset: 0;
    background-color: transparent;
    z-index: 2;
    cursor: wait;
  }
  .quick-view-entries {
    margin-bottom: 1.75rem;
  }
  .quick-view-fab {
    position: relative;
    z-index: 2;
    .quick-view-fab-wrapper {
      position: absolute;
      left: 0;
      bottom: 1rem;
      transform: translateX(calc(-100% - 1rem));
    }
    .quick-view-fab--single {
      @include text-overflow-ellipsis;
      max-width: 250px;
      white-space: nowrap;
    }
  }
  .history-count-wrapper {
    position: relative;
    padding-right: 0.575rem;
    .history-count {
      @include absolute-center-y;
      left: 26px;
      min-width: 1rem;
      padding: 0 2px;
      border: 1px solid transparent;
      border-radius: 10em;
      font-size: 0.675rem;
      color: var(--fts-gray-400);
      text-align: center;
      transition: all 0.3s ease-in-out;
    }
    .fts-btn:hover + .history-count {
      background-color: var(--fts-primary);
      color: #fff;
    }
  }
  .error-wrapper {
    padding: 2rem;
    text-align: center;
    .error-icon {
      height: 80px;
      width: 80px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto 1.25rem;
      border: 2px solid var(--fts-danger);
      border-radius: 50%;
      color: var(--fts-danger);
      > svg {
        color: inherit;
        font-size: 2.5rem;
      }
    }
    .error-title {
      margin-bottom: 0.75rem;
      color: var(--fts-danger);
      font-weight: 500;
      font-size: 1.25rem;
      line-height: 1.75rem;
      word-break: break-word;
    }
    .error-description {
      color: var(--fts-default);
      font-size: 0.875rem;
      line-height: 1.25rem;
      word-break: break-word;
    }
  }
}
.standard-activity-form {
  .standard-activity-form-content {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  .standard-activity-form-title {
    font-size: 1rem;
    text-align: center;
  }
  .standard-activity-state {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    .state-label {
      margin-right: 0.375rem;
      white-space: nowrap;
    }
    .state-dropdown {
      min-width: 0;
    }
    .state-error {
      margin-top: .375rem;
      font-size: .75rem;
      color: var(--fts-danger);
    }
  }
  .standard-activity-comment {
    margin-top: 1rem;
  }
}
.standard-activity-icon {
  margin-right: 0.375rem;
  &.standard-activity-icon-lg {
    font-size: 1.25rem;
  }
}
</style>